// extracted by mini-css-extract-plugin
export default {"longBtn":"css_longBtn__DvZda","modalInput":"css_modalInput__YFy9e"};